export const updateVATUI = (type) => {
    const priceWithVatElements = document.querySelectorAll('.js-price-vat');
    const priceWithoutVatElements = document.querySelectorAll('.js-price-novat');

    if (type === 'with-vat') {
        priceWithVatElements.forEach(el => el.classList.add('show'));
        priceWithoutVatElements.forEach(el => el.classList.remove('show'));
    } else if (type === 'without-vat') {
        priceWithVatElements.forEach(el => el.classList.remove('show'));
        priceWithoutVatElements.forEach(el => el.classList.add('show'));
    }
};

export const initPriceSwitch = () => {
    const priceSwitchToggle = document.querySelector('#price-switch-toggle');
    if (!priceSwitchToggle) return;

    const labelText = document.querySelector('.label-text');
    const slider = priceSwitchToggle.nextElementSibling;
    const serverDefault = priceSwitchToggle.closest('.js-price-switch')?.dataset.vatDefault === '1' ? 'with-vat' : 'without-vat';
    const savedPreference = localStorage.getItem('priceType') || serverDefault;

    priceSwitchToggle.checked = savedPreference === 'with-vat';
    slider.classList.toggle('checked', savedPreference === 'with-vat');
    updateVATUI(savedPreference);

    priceSwitchToggle.addEventListener('change', function () {
        const priceType = priceSwitchToggle.checked ? 'with-vat' : 'without-vat';
        slider.classList.toggle('checked', priceSwitchToggle.checked);
        updateVATUI(priceType);
        localStorage.setItem('priceType', priceType);
    });

    labelText.addEventListener('click', function () {
        priceSwitchToggle.click();
    });
};